module.exports = __webpack_public_path__ + "console/img/machinecore_logo_final@1x.2150c86d.png";